module.exports = __webpack_public_path__ + "static/media/no-company.69a26a2c.png";